import React from 'react'
import '../../styles/Diagnostic/DiagnosticGaz.css'
import { Fade } from 'react-awesome-reveal'
import diagnosticGazSection2 from '../../assets/diagnostic/diagnostic-gaz-section2.jpg'
import { Accordion, Col, Row } from 'react-bootstrap'
import diagnosticGazSection3 from '../../assets/diagnostic/diagnostic-gaz-section3.jpg'
import AccordionText from '../Utils/AccordionText'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function DiagnosticGaz() {

    const section3AccordionData = [
        {
            title: "Expertise et précision :",
            text: "Nos diagnostiqueurs, spécialisés dans le diagnostic gaz, utilisent des équipements à la pointe de la technologie pour détecter tout défaut susceptible de compromettre la sécurité des occupants. Leur expertise garantit une évaluation " +
                "précise et détaillée de l’état de votre installation gaz."
        }, {
            title: "Conformité et sécurité :",
            text: "Le diagnostic gaz réalisé par E5M Diagnostic est conforme aux normes en vigueur, identifiant les risques potentiels et proposant des recommandations pour toute intervention nécessaire. Ce diagnostic est indispensable pour la vente ou " +
                "la location de votre bien, assurant la sécurité des habitants et la tranquillité d’esprit du propriétaire."
        }, {
            title: "Rapport clair et détaillé :",
            text: "Nous vous fournissons un rapport complet et facile à comprendre, détaillant l’état de l’installation gaz de votre propriété. Ce document est essentiel pour informer les futurs acheteurs ou locataires et constitue une preuve de votre " +
                "engagement envers la sécurité."
        }, {
            title: "Réactivité et flexibilité :",
            text: "Conscients de l’importance des délais dans les transactions immobilières, notre équipe s’engage à réaliser votre diagnostic gaz dans les meilleurs délais, tout en assurant un service de qualité."
        }
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic Gaz - E5M Diagnostics" />
                <meta name="description" content="Diagnostic Gaz sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic Gaz - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic Gaz sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/diagnostic-gaz" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/diagnostic-gaz" />
            </Helmet>

            <BrowserView>
                <div id='diagnosticGaz'>
                    <div id='header'>
                        <div id='diagnosticGazHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Diagnostic Gaz</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='diagnosticGazSection1'>
                        <Fade direction={'down'} duration={500}>
                            <h1 className='sectionTitle'>E5M Diagnostics : Votre expert pour un diagnostic gaz sécurisé et conforme</h1>
                            <div className='sectionText'>
                                La sécurité de votre bien immobilier est notre priorité. Chez E5M Diagnostics, nous comprenons l’importance d’un diagnostic gaz fiable et conforme pour la vente ou la location de votre propriété. Notre équipe d’experts
                                certifiés est à votre service pour effectuer un diagnostic gaz complet, vous assurant ainsi de répondre à toutes les obligations légales et de garantir la sécurité des futurs occupants.
                            </div>
                        </Fade>
                    </div>
                    <Row id='diagnosticGazSection2'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticGazSection2Left'>
                                    <h1 className='sectionTitle'>Principe du diagnostic gaz</h1>
                                    <div className='sectionText'>
                                        Il est obligatoire d’effectuer un diagnostic GAZ de l’installation afin d’évaluer les risques pouvant mettre en danger la sécurité des personnes et de leurs biens ; il est réalisé à l’initiative du propriétaire.
                                    </div>
                                    <div className='sectionText'>
                                        Le diagnostic GAZ concerne les installations qui ont plus de 15 ans, il est réalisé sans démontage et doit être conforme à une méthodologie réglementée en vérifiant :
                                    </div>
                                    <div className='sectionText'>
                                        <ul>
                                            <li>La tuyauterie fixe et de ses accessoires</li>
                                            <li>Le raccordement en gaz des appareils</li>
                                            <li>Le système de ventilation et d’aération</li>
                                            <li>La combustion</li>
                                        </ul>
                                    </div>
                                    <div className='sectionText'>
                                        Il concerne toutes les installations de production individuelle de chaleur ou d’eau chaude sanitaire ainsi que les installations d’appareils de cuisson s’ils sont desservis par une installation fixe.
                                    </div>
                                    <div className='sectionText'>
                                        En cas d’anomalie repérée lors du diagnostic gaz, celle-ci est détaillée dans le rapport et notée selon son degré de gravité. Si elle est classée en « Danger Grave Immédiat » (DGI), le diagnostiqueur condamne
                                        immédiatement de manière partielle ou totale l’installation ; le distributeur de gaz est alors prévenu et le cas d’une condamnation totale ce dernier interrompra la fourniture de gaz jusqu’au moment où recevra l’attestation de levée de DGI.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticGazSection2Right'>
                                    <img src={diagnosticGazSection2} id='diagnosticGazSection2Image' alt='diagnostic-gaz-section2' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticGazSection3'>
                        <Col sm={6}>
                            <div id='diagnosticGazSection3Left'>
                                <Fade direction={'right'} duration={500}>
                                    <img src={diagnosticGazSection3} className='diagnosticGazSection3Image' alt='diagnostic-gaz-section3' />
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='diagnosticGazSection3Right'>
                                    <h1 className='sectionTitle'>Pourquoi est-il essentiel de faire un diagnostic gaz ?</h1>
                                    <div id='diagnosticGazSection3Accordion'>
                                        <div className='sectionAccordion'>
                                            <Accordion>
                                                {section3AccordionData.map((item, index) => {
                                                    return (
                                                        <AccordionText
                                                            key={index}
                                                            indexKey={index}
                                                            header={item.title}
                                                            body={item.text}
                                                        />
                                                    )
                                                })}
                                            </Accordion>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='diagnosticGazSection4'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitle'>Contactez E5M Diagnostics pour un diagnostic gaz fiable</h1>
                            <div className='sectionText'>
                                Que vous soyez vendeur ou bailleur, le diagnostic gaz est une démarche indispensable pour garantir la conformité et la sécurité de votre bien. En choisissant E5M Diagnostics, vous optez pour un service professionnel, précis et conforme aux normes en vigueur. Contactez-nous dès aujourd’hui pour bénéficier de notre expertise et assurer la sécurité de votre propriété avec un diagnostic gaz complet et fiable.
                            </div>
                        </Fade>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id='diagnosticGaz'>
                    <div id='header'>
                        <div id='diagnosticGazHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Diagnostic Gaz</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='diagnosticGazSection1Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>E5M Diagnostics : Votre expert pour un diagnostic gaz sécurisé et conforme</h1>
                            <div className='sectionTextMobile'>
                                La sécurité de votre bien immobilier est notre priorité. Chez E5M Diagnostics, nous comprenons l’importance d’un diagnostic gaz fiable et conforme pour la vente ou la location de votre propriété. Notre équipe d’experts
                                certifiés est à votre service pour effectuer un diagnostic gaz complet, vous assurant ainsi de répondre à toutes les obligations légales et de garantir la sécurité des futurs occupants.
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticGazSection2Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Principe du diagnostic gaz</h1>
                            <div className='sectionTextMobile'>
                                Il est obligatoire d’effectuer un diagnostic GAZ de l’installation afin d’évaluer les risques pouvant mettre en danger la sécurité des personnes et de leurs biens ; il est réalisé à l’initiative du propriétaire.
                            </div>
                            <div className='sectionTextMobile'>
                                Le diagnostic GAZ concerne les installations qui ont plus de 15 ans, il est réalisé sans démontage et doit être conforme à une méthodologie réglementée en vérifiant :
                            </div>
                            <div className='sectionTextMobile'>
                                <ul>
                                    <li>La tuyauterie fixe et de ses accessoires</li>
                                    <li>Le raccordement en gaz des appareils</li>
                                    <li>Le système de ventilation et d’aération</li>
                                    <li>La combustion</li>
                                </ul>
                            </div>
                            <div className='sectionTextMobile'>
                                Il concerne toutes les installations de production individuelle de chaleur ou d’eau chaude sanitaire ainsi que les installations d’appareils de cuisson s’ils sont desservis par une installation fixe.
                            </div>
                            <div className='sectionTextMobile'>
                                En cas d’anomalie repérée lors du diagnostic gaz, celle-ci est détaillée dans le rapport et notée selon son degré de gravité. Si elle est classée en « Danger Grave Immédiat » (DGI), le diagnostiqueur condamne
                                immédiatement de manière partielle ou totale l’installation ; le distributeur de gaz est alors prévenu et le cas d’une condamnation totale ce dernier interrompra la fourniture de gaz jusqu’au moment où recevra l’attestation de levée de DGI.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={diagnosticGazSection2} id='diagnosticGazSection2ImageMobile' alt='diagnostic-gaz-section2' />
                        </Fade>
                    </div>
                    <div id='diagnosticGazSection3Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <img src={diagnosticGazSection3} className='diagnosticGazSection3ImageMobile' alt='diagnostic-gaz-section3' />
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Pourquoi est-il essentiel de faire un diagnostic gaz ?</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section3AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticGazSection4Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Contactez E5M Diagnostics pour un diagnostic gaz fiable</h1>
                            <div className='sectionTextMobile'>
                                Que vous soyez vendeur ou bailleur, le diagnostic gaz est une démarche indispensable pour garantir la conformité et la sécurité de votre bien. En choisissant E5M Diagnostics, vous optez pour un service professionnel, précis et conforme aux normes en vigueur. Contactez-nous dès aujourd’hui pour bénéficier de notre expertise et assurer la sécurité de votre propriété avec un diagnostic gaz complet et fiable.
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>



    )

}

export default DiagnosticGaz